import {prospectusUrl} from '../api';

const saveProspectus = (prospectus, token) => async (dispatch) => {

    const response = await fetch( prospectusUrl() + 'save', {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            data: prospectus,
        }),
    })

    const data = await response.json();

    dispatch({
        type: 'SAVED_PROSPECTUS',
        payload: data
    })

    // Share the prospectus.
    dispatch({ type : 'UPDATE_SIDEBAR_MODE', payload: { mode: 'share'  }});
}

export default saveProspectus;